module.exports = __webpack_public_path__ + "8e934161c898fdd75106d69eceb827ac.pdf";